(function() {
  'use strict';

  function FAQsController(Profile, FAQs, FAQSearch, List, Security, $translate, Utils) {
    var ctrl = this;
    ctrl.options = {};

    Utils.setPageTitle('Frequently Asked Questions');

    ctrl.options = { trackBy: '_id' };

    ctrl.searchModel = Profile.getListPreferences('faqs').current;

    ctrl.list = new List({ search: FAQSearch.search, model: ctrl.searchModel, idField: '_id' });

    FAQs.findAll({ cached: false })
      .then(function(data) {
        ctrl.list.doLoadItems(data);
      });

    ctrl.actions = [
      {
        label: $translate.instant('New FAQ'),
        icon: 'icon-edit',
        route: ['/faqs/new'],
        showCondition: Security.hasPermission.bind(this, 'faqs.edit'),
        klass: 'btn-success'
      }
    ];

    // Add loaded property for kz-loading directive
    ctrl.loaded = true;
  }

  FAQsController.$inject = [
    'ProfileService',
    'FAQsService',
    'FAQSearch',
    'ListFactory',
    'SecurityService',
    '$translate',
    'UtilsService'
  ];

  angular.module('component.faqs')
    .controller('FAQsController', FAQsController);
})();
